module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/hoodie/2-1-e88a0e00206f2f35b96fbbfdf2fb95e7.jpg";